//#region ImportSection
import React, { useEffect, useState } from "react";
import { Table, Button, ButtonGroup } from "reactstrap";
import swal from "sweetalert";
import { t } from "i18next";
import { GetLanguageString, NoResult } from "../../helper/Components";
import {
  applyClassToCharacters,
  LoadingSpinner,
} from "../../../constants/const";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { IoAdd } from "react-icons/io5";
import ApiHabibProgress from "./ApiHabibProgress";
import AddHabibProgress from "./AddHabibProgress";
import EditHabibProgress from "./EditHabibProgress";

//#endregion ImportSection

const HabibProgressType = ({ activeTab }) => {
  //#region StateSection

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [habibProgress, sethabibProgress] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedProgress, setselectedProgress] = useState({});
  //#endregion StateSection
  //#region functionSection
  const handleDelete = (tagValue) => {
    if (tagValue.id !== 0) {
      swal({
        title: t("common_delete_message"),
        text: t("common_delete_detail_message"),
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          ApiHabibProgress()
            .DeleteSetupHabibProgress(tagValue)
            .then((res) => {
              swal({
                title: t("deleted_habib_progress"),
                className: GetSelectedLanguage() === "en" ? "" : "ur",
                icon: "success",
                buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
              });
              setRefresh(!refresh);
            })
            .catch((err) => {
              swal({ title: err.response.data, icon: "error", buttons: "OK" });
            });
        }
      });
    } else {
      swal({
        title: t("tag_have_documents"),
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "error",
        buttons: "OK",
      });
    }
  };
  const handleEdit = (tag) => {
    setselectedProgress(tag);
    setEditModal(true);
  };
  //#endregion functionSection

  //#region useEffectSection
  useEffect(() => {
    if (activeTab === "habibprogress") {
      setLoading(true);
      ApiHabibProgress()
        .GetSetupHabibProgress()
        .then((res) => {
          sethabibProgress(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [refresh, activeTab]);
  //#endregion useEffectSection

  return (
    <>
      {addModal ? (
        <AddHabibProgress
          setAddModal={setAddModal}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {editModal ? (
        <EditHabibProgress
          selectedProgress={selectedProgress}
          setEditModal={setEditModal}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      ) : null}
      {!loading ? (
        <div className="ibox">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="habib_progress_type" />}</h5>
            <Button
              color="white"
              size="sm"
              className={GetCustomStyles().btn_style}
              onClick={() => setAddModal(true)}
            >
              <IoAdd
                size={18}
                color="#18A689"
                style={{ marginRight: 3, marginBottom: 1 }}
              />
              <GetLanguageString props="add_habib_progress_name" />
            </Button>
          </div>
          <div className="ibox-content">
            {habibProgress.length !== 0 ? (
              <div className="table-responsive">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {<GetLanguageString props="habib_progress_name" />}
                      </th>
                      <th className="text-center">
                        {<GetLanguageString props="common_action" />}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {habibProgress.map((record, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-t-custom">{index + 1}</td>

                          <td>
                            {applyClassToCharacters(record.progressName, "ur")}
                          </td>
                          <td className="text-center">
                            <ButtonGroup>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleEdit(record)}
                              >
                                <GetLanguageString props="common_edit" />
                              </Button>{" "}
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleDelete(record)}
                              >
                                <GetLanguageString props="common_delete" />
                              </Button>{" "}
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult />
            )}
          </div>
        </div>
      ) : (
        LoadingSpinner()
      )}
    </>
  );
};

export default HabibProgressType;
